import React from "react";

export default class BlogPostResume extends React.Component 
{
    constructor(props)
    {
        super(props);

        this.post = this.props.post;    
        this.firstImage = this.props.firstImage;
        this.state = {
            isVertical: undefined,
            imageURL: ''
        }
    }

    getImage = (image) =>
    {
        if(image === null)
        {
            return(<></>)
        }

        const alt = image.alt !== '' ? image.alt : 'hometown';
        
        return(
            <div className="main-image">
                <img src={image.path} alt={alt} loading={this.firstImage ? 'eager' : 'lazy'}/>
            </div>
        )
    }

    getVideoImage = (video) =>
        {
            if(video === null)
            {
                return(<></>)
            }
            
            // get the video id from the URL
            let videoId = video.split("v=")[1]
            if (!videoId) {
                videoId = video.split("/embed/")[1]
            }

            // mobile thumbnail
            const mobileURL = `https://img.youtube.com/vi/${videoId}/oardefault.jpg`
            const horizontalURL = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`

            if (typeof window !== 'undefined' && this.state.imageURL === '') {
                const img = new Image()
                img.src = mobileURL
                img.onload = () => {
                if (img.width > img.height) {
                    this.setState({ imageURL: horizontalURL, isVertical: false }) 
                } else {
                    this.setState({ imageURL: mobileURL, isVertical: true }) 
                }
                }
            }

            return (
                <div className={`main-image ${this.state.isVertical ? 'vertical' : 'horizontal'}`}>
                    <img
                        src={this.state.imageURL}
                        alt="hometown"
                        loading={this.firstImage ? "eager" : "lazy"}
                    />
                </div>
            )
        }
    
    render() 
    {    
        return (
            <div class="post single-item">
                
                <div className="resume">
                    <a href={this.post.url}>
                        {this.post.media_type === 'video' ? this.getVideoImage(this.post.video) : this.getImage(this.post.image)}
                    </a>

                    <h2><a href={this.post.url}>{this.post.title}</a></h2>

                    <ul className="tags">
                    {                
                        this.post.tags.map(tag =>
                        {                        
                            return (
                                tag.id !== 'success' ? (
                                <li class="big"><a href={'/blog/tags/'+tag.slug}>{tag.name}</a></li>
                                ) : (
                                <li class="big"><a href={'/pro/guide/tags/'+tag.slug}>{tag.name}</a></li>
                                )
                            )
                        })
                    }
                    </ul>
                    
                    <div 
                        dangerouslySetInnerHTML={{__html: this.post.teaser}}>
                    </div>

                    <a href={this.post.url} className="continue">Continue Reading →</a>
                </div>

            </div>  
        )
    }
};